import Barinade from "../../core/assets/oot/ennemies/cleanup/barinade_200x200.png";
import Bongo from "../../core/assets/oot/ennemies/cleanup/bongo_200x200.png"
import Ghoma from "../../core/assets/oot/ennemies/cleanup/ghoma_200x200.png";
import KD from "../../core/assets/oot/ennemies/cleanup/king_dodongo_200x200.png";
import Morpha from "../../core/assets/oot/ennemies/cleanup/morpha_200x200.png"
import PG from "../../core/assets/oot/ennemies/cleanup/pg_200x200.png";
import Twinrova from "../../core/assets/oot/ennemies/cleanup/twinrova_200x200.png";
import Volvagia from "../../core/assets/oot/ennemies/cleanup/volvagia_200x200.png";
import Anubis from "../../core/assets/oot/ennemies/cleanup/anubis_200x200.png";
import Armos from "../../core/assets/oot/ennemies/cleanup/armos_200x200.png";
import BadyDodongo from "../../core/assets/oot/ennemies/cleanup/baby_dodongo_200x200.png";
import Beamos from "../../core/assets/oot/ennemies/cleanup/beamos_200x200.png";
import Biri from "../../core/assets/oot/ennemies/cleanup/biri_200x200.png";
import Bubble from "../../core/assets/oot/ennemies/cleanup/blue_bubble_200x200.png";
import Tektike from "../../core/assets/oot/ennemies/cleanup/tektike_200x200.png";
import DeadHand from "../../core/assets/oot/ennemies/cleanup/deadhand_200x200.png";
import DekuBaba from "../../core/assets/oot/ennemies/cleanup/deku_baba_200x200.png";
import DekuScrub from "../../core/assets/oot/ennemies/cleanup/deku_scrub_200x200.png";
import Dinolfos from "../../core/assets/oot/ennemies/cleanup/lizalfos_dinalfos_200x200.png";
import Dodongo from "../../core/assets/oot/ennemies/cleanup/dodongo_200x200.png";
import FlareDancer from "../../core/assets/oot/ennemies/cleanup/flare_dancer_200x200.png";
import FlyingPot from "../../core/assets/oot/ennemies/cleanup/flyint_pot_200x200.png";
import Freezard from "../../core/assets/oot/ennemies/cleanup/freezard_200x200.png";
import GhomaLarva from "../../core/assets/oot/ennemies/cleanup/ghoma_larva_200x200.png";
import Guay from "../../core/assets/oot/ennemies/cleanup/guay_200x200.png";
import IronKnuckle from "../../core/assets/oot/ennemies/cleanup/iron_knuckles_200x200.png";
import Keese from "../../core/assets/oot/ennemies/cleanup/keese_200x200.png";
import LikeLike from "../../core/assets/oot/ennemies/cleanup/like_like_200x200.png";
import Moblin from "../../core/assets/oot/ennemies/cleanup/moblin_200x200.png";
import Octorock from "../../core/assets/oot/ennemies/cleanup/octorock_200x200.png";
import Peahat from "../../core/assets/oot/ennemies/cleanup/peahat_200x200.png";
import ReDead from "../../core/assets/oot/ennemies/cleanup/redead_gibdo_200x200.png";
import Shabom from "../../core/assets/oot/ennemies/cleanup/shabom_200x200.png";
import ShellBlade from "../../core/assets/oot/ennemies/cleanup/seashell_200x200.png";
import SkullKid from "../../core/assets/oot/ennemies/cleanup/skullkid_200x200.png";
import Skultulla from "../../core/assets/oot/ennemies/OoT_Skulltula_Artwork.png";
import Skullwalltula from "../../core/assets/oot/ennemies/cleanup/skullwalltula_200x200.png";
import Spike from "../../core/assets/oot/ennemies/cleanup/spike_200x200.png";
import Stalfos from "../../core/assets/oot/ennemies/cleanup/stalfos_200x200.png";
import Stinger from "../../core/assets/oot/ennemies/cleanup/stinger_200x200.png";
import Tailpasaran from "../../core/assets/oot/ennemies/cleanup/tailpasaran_200x200.png";
import TorchSlug from "../../core/assets/oot/ennemies/cleanup/torch_slug_200x200.png";
import Floormaster from "../../core/assets/oot/ennemies/cleanup/wallmaster_200x200.png";
import WallMaster from "../../core/assets/oot/ennemies/cleanup/wallmaster_200x200.png";
import Wolfos from "../../core/assets/oot/ennemies/cleanup/wolfos_200x200.png";
import Darklink from "../../core/assets/oot/ennemies/cleanup/dark_link_200x200.png";
import Tentacles from "../../core/assets/oot/ennemies/cleanup/tentacle_200x200.png";
import { EnnemyDto } from "./EnnemyTracker";


export const StalfosEnnemy: EnnemyDto = { name: 'Stalfos', img: Stalfos, dungeonsMandatory: ["Forest", "Ganon", "GTG"], isObtained: false, type: "monster"};
export const BubbleEnnemy: EnnemyDto =  { name: 'Bubble', img: Bubble, checks: ["Forest Temple Map Chest"], dungeonsMandatory: ["Forest"], isObtained: false , type: "monster"};
export const DekuScrubEnnemy : EnnemyDto =   { name: 'Deku Scrub', img: DekuScrub, dungeonsMandatory: ["Deku"], isObtained: false, type: "monster"};
export const ArmosSoul: EnnemyDto = { name: 'Armos', img: Armos, checks: ["Dodongos Cavern Compass Room Armos : if you want to leave the room", "Early Child Spirit Temple", "Spirit Temple Adult Iron Knuckle : need armos to access knuckle"], dungeonsMandatory: ["DC", "Spirit"], isObtained: false , type: "monster"}
export const BeamosSoul: EnnemyDto = { name: 'Beamos', img: Beamos, checks: ["Gerudo Training Ground Beamos Chest : GTG first right room check", "Spirit Temple Beyond Anubis Room"], dungeonsMandatory: ["Spirit", "GTG"] , isObtained: false, type: "monster"}
export const DeadHandSoul: EnnemyDto = { name: 'Dead Hand', img: DeadHand, dungeonsMandatory: ["BotW", "Shadow"] , isObtained: false, type: "monster"}
export const DinolfosLizalfosSoul: EnnemyDto = { name: 'Dinolfos & Lizalfos', img: Dinolfos, checks: ["Dodongos Cavern Far Bridge : Lizardfos are a logical access to Bomb chest", ""], dungeonsMandatory: ["GTG", "Ganon"] , isObtained: false, type: "monster"}
export const AnubisSoul: EnnemyDto = { name: 'Anubis', img: Anubis, checks: ["Spirit Temple Beyond Anubis Room", "Spirit Temple Child Anubis"], dungeonsMandatory: ["Spirit"] , isObtained: false, type: "monster"}
export const FlareDancerSoul: EnnemyDto = { name: 'Flare Dancer', img: FlareDancer, dungeonsMandatory: ["Fire"] , isObtained: false, type: "monster"}
export const FloormasterSoul: EnnemyDto = { name: 'Floormaster', img: Floormaster, dungeonsMandatory: ["Forest", "Shadow"] , isObtained: false, type: "monster"}
export const FlyingPotSoul: EnnemyDto = { name: 'Flying Pot', img: FlyingPot, dungeonsMandatory: ["Shadow"] , isObtained: false, type: "monster"}
export const FreezardSoul: EnnemyDto = { name: 'Freezard', img: Freezard, dungeonsMandatory: ["Ice"], isObtained: false, type: "monster"}
export const IronKnuckleSoul: EnnemyDto = { name: 'Iron Knuckle', img: IronKnuckle, dungeonsMandatory: ["Spirit", "Ganon"], isObtained: false, type: "monster"}
export const KeeseSoul: EnnemyDto =  { name: 'Keese', img: Keese, dungeonsMandatory: ["Shadow", "Fire", "Spirit", "GTG"], isObtained: false, type: "monster"}
export const LikeLikeSoul: EnnemyDto = { name: 'Like-Like', img: LikeLike, dungeonsMandatory: ["Shadow", "GTG"] , isObtained: false, type: "monster"}
export const OctorockSoul: EnnemyDto = { name: 'Octorock', img: Octorock, checks: ["Jabu Jabus Belly Wiggler Platforms Octorok"], dungeonsMandatory: ["Jabu"] , isObtained: false, type: "monster"}
export const RedeadGibdoSoul: EnnemyDto = { name: 'ReDead & Gibdo', img: ReDead, dungeonsMandatory: ["Shadow"] , isObtained: false, type: "monster"}
export const ShabomSoul: EnnemyDto = { name: 'Shabom', img: Shabom, checks: ["Jabu Jabus Belly Compass Chest"], dungeonsMandatory: ["Jabu"] , isObtained: false, type: "monster"}
export const ShellBladeSoul: EnnemyDto =  { name: 'Shell Blade', img: ShellBlade, dungeonsMandatory: ["Water"], isObtained: false , type: "monster"}
export const SpikeSoul: EnnemyDto = { name: 'Spike', img: Spike, dungeonsMandatory: ["Water"] , isObtained: false, type: "monster"};
export const StingerSoul: EnnemyDto = { name: 'Stinger', img: Stinger, checks: ["Jabu Jabus Belly Boomerang Chest"], dungeonsMandatory: ["Jabu"] , isObtained: false, type: "monster"}
export const TorchSlugSoul: EnnemyDto = { name: 'Torch Slug', img: TorchSlug, dungeonsMandatory: ["Fire", "GTG"] , isObtained: false, type: "monster"}
export const WolfosSoul: EnnemyDto =     { name: 'Wolfos', img: Wolfos, checks: ["Gerudo Training Ground Heavy Block Room : just before F2", "Sacred Forest Meadow access : must be killed to open the gate"], dungeonsMandatory: ["GTG"] , isObtained: false, type: "monster"}
export const DarklinkSoul: EnnemyDto =     { name: 'Dark Link', img: Darklink , dungeonsMandatory: ["Water"], isObtained: false, type: "monster"}
export const TentaclesSoul: EnnemyDto =     { name: 'Jabu Tentacles', img: Tentacles , dungeonsMandatory: ["Jabu"], isObtained: false, type: "monster"}


export const GhomaSoul: EnnemyDto = { name: 'Ghoma', img: Ghoma, dungeonsMandatory: ["Deku"] , isObtained: false, type: "boss", order: 1}
export const KdSoul: EnnemyDto = { name: 'King Dodongo', img: KD, dungeonsMandatory: ["DC"] , isObtained: false, type: "boss", order: 2}
export const BarinadeSoul: EnnemyDto = { name: 'Barinade', img: Barinade, dungeonsMandatory: ["Jabu"] , isObtained: false, type: "boss", order: 3}
export const PgSoul: EnnemyDto = { name: 'Phantom Ganon', img: PG , dungeonsMandatory: ["Forest"], isObtained: false, type: "boss", order: 4}
export const VolvagiaSoul: EnnemyDto = { name: 'Volvagia', img: Volvagia , dungeonsMandatory: ["Fire"], isObtained: false, type: "boss", order: 5}
export const MorphaSoul: EnnemyDto = { name: 'Morpha', img: Morpha, dungeonsMandatory: ["Water"] , isObtained: false, type: "boss", order: 6}
export const BongoSoul: EnnemyDto = { name: 'Bongo Bongo', img: Bongo, dungeonsMandatory: ["Shadow"] , isObtained: false, type: "boss", order: 7}
export const TwinrovaSoul: EnnemyDto = { name: 'Twinrova', img: Twinrova, dungeonsMandatory: ["Spirit"] , isObtained: false, type: "boss", order: 8}


export const BossesSoul: Array<EnnemyDto> = [
    GhomaSoul,
    KdSoul,
    BarinadeSoul,
    PgSoul,
    VolvagiaSoul,
    MorphaSoul,
    BongoSoul,
    TwinrovaSoul
]

export const UsefullEnnemySoul: Array<EnnemyDto> = [
    DekuScrubEnnemy,
    ArmosSoul,
    StingerSoul,
    ShabomSoul,
    OctorockSoul,
    StalfosEnnemy,
    BubbleEnnemy,
    FloormasterSoul,
    TorchSlugSoul,
    KeeseSoul,
    FlareDancerSoul,
    SpikeSoul,
    ShellBladeSoul,
    DarklinkSoul,
    AnubisSoul,
    IronKnuckleSoul,
    BeamosSoul,
    RedeadGibdoSoul,
    LikeLikeSoul,
    DeadHandSoul,
    FlyingPotSoul,
    WolfosSoul,
    FreezardSoul,
    DinolfosLizalfosSoul,
    TentaclesSoul,
    ...BossesSoul
]



export const EnnemySouls: Array<EnnemyDto> = [
    
    { name: 'Baby Dodongo', img: BadyDodongo , type: "monster"},
    { name: 'Biri & Bari', img: Biri, checks: ["Jabu Jabus Belly Last Tentacle"] , type: "monster"},
    { name: 'Deku Baba', img: DekuBaba, type: "monster" },
    { name: 'Dodongo', img: Dodongo, type: "monster" },
    { name: 'Ghoma Larva', img: GhomaLarva , type: "monster"},
    { name: 'Guay', img: Guay, type: "monster" },
    { name: 'Moblin', img: Moblin, type: "monster" },
    { name: 'Peahat', img: Peahat, type: "monster" },
    { name: 'Skull Kid', img: SkullKid, type: "monster" },
    { name: 'Skulltula', img: Skultulla , type: "monster"},
    { name: 'Skullwalltula', img: Skullwalltula, type: "monster" },
    { name: 'Tektike', img: Tektike, checks: [] , type: "monster"},
    { name: 'Tailpasaran', img: Tailpasaran , type: "monster"},
    { name: 'Wallmaster', img: WallMaster, type: "monster" },
    ...UsefullEnnemySoul
]

export const BossSouls: Array<EnnemyDto> = [
    { name: 'Ghoma', img: Ghoma, dungeonsMandatory: ["Deku"] , type: "boss"},
    { name: 'KD', img: KD, dungeonsMandatory: ["DC"] , type: "boss"},
    { name: 'Barinade', img: Barinade, dungeonsMandatory: ["Jabu"] , type: "boss"},
    { name: 'PG', img: PG, dungeonsMandatory: ["Forest"] , type: "boss"},
    { name: 'Volvagia', img: Volvagia, dungeonsMandatory: ["Fire"] , type: "boss"},
    { name: 'Morpha', img: Morpha, dungeonsMandatory: ["Water"] , type: "boss"},
    { name: 'Bongo', img: Bongo, dungeonsMandatory: ["Shadow"] , type: "boss"},
    { name: 'Twinrova', img: Twinrova, dungeonsMandatory: ["Spirit"], type: "boss" },
]